import { Component, OnInit, Output } from '@angular/core';
import { FLAG_KEYS, FeatureFlagService } from '@services/feature-flag.service';
import { KillSwitchComponent } from '@pages/kill-switch/kill-switch.component';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '@components/navbar/navbar.component';
import { AuthService, EUAV3UserInfo } from '@shared/auth/auth.service';
import { FullStory } from '@fullstory/browser';
import { AIService } from '@services/ai.service';
import { SessionService } from '@services/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, KillSwitchComponent, NavbarComponent],
})
export class AppComponent implements OnInit {
  @Output() isMobile = false;
  siteKillSwitch = false;

  constructor(
    private readonly authService: AuthService,
    private readonly featureFlagService: FeatureFlagService,
    private readonly aiService: AIService,
    private readonly sessionService: SessionService,
  ) {
    authService.checkAuth();
  }

  ngOnInit() {
    // Detect device and browser info and set information
    const userAgent = navigator.userAgent;
    // Improved mobile device detection
    if (/Mobi|iPhone|Android|Windows Phone|IEMobile|Mobile/i.test(userAgent)) {
      this.isMobile = true;
    }

    this.sessionService.updateMobileDeviceStatus(this.isMobile);

    // Check the feature flags
    this.featureFlagService.getFeatureFlags().subscribe((flags) => {
      this.siteKillSwitch = flags[FLAG_KEYS.KILL_SWITCH];
    });

    // Handle authentication and session creation
    this.authService.pingUserInfo$.subscribe((userInfo: EUAV3UserInfo) => {
      if (userInfo) {
        this.aiService
          .createSession()
          .then((response) => console.log('Created session', response.session_id))
          .catch((err) => {
            console.error('Error creating session', err);
          });
        FullStory.identify(userInfo.email);
      }
    });
  }
}
